import React from 'react'
import AutoComplete from '../flowautocomplete/flowautocomplete'
import { templates } from '../../config/templates'
import useFlow from '../../hooks/useFlow'
import CreateProjectDialog from './create-project'
import { listConnections } from '../../api-client/data'
import { useDispatch, useSelector, Actions } from '../../stores/dashboard.store'
import useFetch from '../../hooks/useFetch'
import { SettingsNavigationItems } from '../../config/nav'

const SearchTemplateFlow = ({ onClose, onSubmit }) => {
    const flow = useFlow({ onBack: onClose, onSubmit: onSubmit })
    const connections = useFetch(listConnections)
    const { plan } = useSelector()
    const dispatch = useDispatch()

    const autoCorrectComplete = (args) => {
        if (!plan?.nodeAccessibility.includes(args?.accessibility)) {
            dispatch(Actions.SetDashboardError, { title: 'Upgrade Plan', description: 'You must upgrade your plan to use this feature.' })
            onClose()
            return
        }

        if (Array.isArray(args?.requiredConnections)) {
            // it needs all of the required connections            
            if (!args?.requiredConnections?.every(x => !!connections.data.find(k => k?.accountId === x))) {
                onClose()
                dispatch(Actions.SetDashboardError, {
                    title: "Connection Required",
                    description: "To use this node, you must first connect to the 3rd party application",
                    navigation: { nav: SettingsNavigationItems._id, view: SettingsNavigationItems.Connections },
                })
                return
            }
        }

        flow.onClickChange("template")(args)
    }

    switch (flow.step) {
        case 0: {
            return (
                <AutoComplete
                    onSelect={autoCorrectComplete}
                    items={templates}
                    onClose={onClose}
                    selectionInfo={{}}
                />
            )
        }
        case 1: {
            return (
                <CreateProjectDialog
                    onClose={flow.decrementStep}
                    onSubmit={flow.finalStageSubmit("project")}
                    show={true}
                />
            )
        }
        default: {
            return null
        }
    }
}

export default function SearchTemplate({ onClose, show, onSubmit }) {
    return show && <SearchTemplateFlow onClose={onClose} onSubmit={onSubmit} />
}